import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  const $dataValidate = $('form[data-validate]')
  debugLogScriptName($dataValidate, 'validate-required.js') // DEBUG
  $dataValidate.on('change', function(e) {
    var $form = $(this),
      $submit = $(this).find('[type="submit"]'),
      $requiredInputs = $form.find('[required]'),
      $filledRequiredInputs = $requiredInputs.filter(function(index) {
        return $(this).val()
      })

    var $groupRequired = $form.find('[group-required]')
    var allGroupsValid = true

    if ($groupRequired.length) {
      // var allGroupsValid = false;
      var groupsValid = []

      $groupRequired.each(function(i, el) {
        var $el = $(el),
          name = $el.attr('name'),
          $els = $form.find('[name="' + name + '"]')

        if ($els.filter(':checked').length > 0) {
          groupsValid.push(true)
        } else {
          groupsValid.push(false)
        }
      })

      allGroupsValid = groupsValid.every(function(group) {
        return group
      })
    }

    if (
      $requiredInputs.length == $filledRequiredInputs.length &&
      allGroupsValid
    ) {
      $submit.prop('disabled', false)
    } else {
      $submit.prop('disabled', true)
    }
  })
})
